import React, { useState } from 'react';
import Tooltip from "@material-ui/core/Tooltip";

function Favorites({data}) {

  const [listData, setlistData] = useState(data);

  function updatelistAPI(ticker) {
    const url = "/favorite_item/" + ticker;
    const msg = fetch(url, {method: 'DELETE'})
      .then(resp => resp.json)

    return msg;
  }

  function updateList(e, item) {
    e.preventDefault();
    const list = data.filter(i => i.ticker !== item.ticker)
    updatelistAPI(item.ticker)
    return setlistData(list);
  }

  function truncate(str, n){
    return (str.length > n) ? str.substr(0, n-1) + '...' : str;
  };

  function recommendationClass(decision_color) {
    if (decision_color == 'red') {
      return 'badge-danger badge-pill'
    } else if (decision_color == 'green') {
      return 'badge-success badge-pill'
    } else {
      return 'badge-grey badge-pill'
    }
  }

  function tableRowClass(decision_color) {
    if (decision_color == 'red') {
      return 'table-danger'
    } else if (decision_color == 'green') {
      return 'table-success'
    } else if (decision_color == 'blue') {
      return 'table-secondary'
    } else {
      return 'table-secondary'
    }
  }

  return (
    <div>
      <div className="page-header">
        <h3 className="page-title"> </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item"><a href="/profile">Profile</a></li>
            <li className="breadcrumb-item active" aria-current="page">Favorites</li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Favorites</h4>
              <p className="card-description"></p>
              { listData.length > 0  ?
              <div className="table-responsive">
                <table className="table table-hover table-bordered table-sm table-striped">
                  <thead>
                    <tr>
                      <th className="table-dark"><strong>Ticker</strong></th>
                      <th className="table-dark"><strong>Name</strong></th>
                      <th className="table-dark"><strong>Consideration</strong></th>
                      <th className="table-dark"><strong>Decision</strong></th>
                      <th className="table-dark"><strong>Price</strong></th>
                      <th className="table-dark"><strong>Change</strong></th>
                      <th className="table-dark"><strong>Margin of safety</strong></th>
                      <th className="table-dark"><strong>Payback Time</strong></th>
                      <th className="table-dark"><strong>Value Score</strong></th>
                      <th className="table-dark"><strong>Actions</strong></th>
                    </tr>
                  </thead>
                  <tbody>
                    {listData.map((item =>
                      <tr className={tableRowClass(item.default_valuation?.recommendation_color)}>
                        <td>
                          <a target="_blank" rel="noopener noreferrer" href={item.url}><strong>{item.ticker}</strong></a>
                        </td>
                        <td>
                          {truncate(item.company, 20)}
                        </td>
                        <td>
                          <span>
                            {item.default_valuation?.recommendation}
                          </span>
                         </td>
                        <td>
                          {item.default_valuation?.decision}
                        </td>
                        <td style={{ color: item.quote?.change_percent_color }}>
                          { item.default_valuation?.price_in_words }
                        </td>
                        <td style={{ color: item.quote?.change_percent_color }}>
                          {item.quote?.change_percent}
                        </td>
                        <td>
                          {item.default_valuation?.margin_of_safety_in_words}
                        </td>
                        <td>
                          {item.default_valuation?.payback_time?.current_payback_time}
                        </td>
                        <td>{item.value_score}%</td>
                        <td>
                          <Tooltip
                            title={"Remove " + item.ticker}
                            placement="bottom"
                            arrow
                          >
                            <a href="#" onClick={(e) => updateList(e, item) } ><i className="material-icons">delete</i></a>
                          </Tooltip>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              : <p className="card-description">There are no items in your favorites</p> }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Favorites;
